import { createAction, props } from '@ngrx/store';
import { ApiDataSection } from '../../interfaces';

export const initializeApiData = createAction(
  '[Api Data] Initialize',
  props<{ sessionKey: string }>()
);

export const getSections = createAction(
  '[Api Data] Get Sections',
  props<{ sessionKey: string }>()
);

export const getSectionsSuccess = createAction(
  '[Api Data] Get Sections Success',
  props<{ sections: ApiDataSection[] }>()
);

export const getSectionsFailure = createAction('[Api Data] Get Sections Failure');
